import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FolderDto } from '@picflow/types';
import { firstValueFrom } from 'rxjs';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { AnalyticsService } from '../../../services/analytics.service';
import { OnGetData } from '../../../services/dialog.service';
import { FolderService } from '../../../services/folder.service';
import { ToastService } from '../../../services/toast.service';
import { InputFieldComponent } from '../../../shared-extra/components/input-field/input-field.component';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { AutofocusDirective } from '../../../shared/directives/autofocus.directive';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-create-folder-dialog',
  templateUrl: './create-folder-dialog.component.html',
  styleUrls: ['./create-folder-dialog.component.scss'],
  standalone: true,
  imports: [
    SvgComponent,
    FormsModule,
    ReactiveFormsModule,
    InputFieldComponent,
    ButtonDirective,
    LoadingIndicatorComponent,
    AutofocusDirective,
  ],
})
export class CreateFolderDialogComponent implements OnGetData {
  private folderService = inject(FolderService);
  private analytics = inject(AnalyticsService);
  private toasts = inject(ToastService);
  dialogName = 'create-folder';
  close: (...args) => void;
  submitting = false;
  parentFolder: FolderDto;
  form = new FormGroup({
    folderName: new FormControl('', Validators.required),
  });

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40 };
  }

  onGetData(data: { parent: FolderDto }, close: (...args) => void): void {
    this.close = close;
    this.parentFolder = data?.parent;
  }

  async submit() {
    if (this.submitting) return;
    if (!this.form.valid) return;
    this.submitting = true;
    const folder = await firstValueFrom(
      this.folderService.createFolder(this.form.value.folderName, this.parentFolder?.id)
    );
    this.toasts.add('Folder created', 'success');
    this.analytics.track('folder_created');
    this.close(folder);
  }
}
